import React, { useEffect, useState, ChangeEvent, FormEvent} from "react";
import classes from "./HomeItem.module.css";
import popularSearch from "./popularSearchTopics";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Section } from "../../components/SectionBox";
import { NewsCard } from "../../components/NewsCard";
import { Bank, BankProps } from "../../components/BankCard";
import { ProductCard, ProductCardProps } from "../../components/ProductCard";
import { PaginationBox } from "../../components/TabAndPaginationBox";
import LoadingSign from "../../components/LoadingSign";
import { dateFormatter } from "../../utils/dateFormatter";

// Homepage Banner
export function Banner() {
  return (
    <div className={classes.banner}>
      <button className={classes.vector}/>
      <b>Provide Neobank-er with</b>
      <br />
      <i className={classes.darker}>Insightful, Precise </i>
      <b>Statistic & Data</b>
    </div>
  );
}

//Moved to Footer
/* export function AIChatBot() {
    const [openChatBot, setOpenChatBot] = useState(true);
  
    const toggleAIChatBot = () =>{
      setOpenChatBot((prevState) => !prevState);
    };

    type Message = {
      content: string;
      sender: string;
      timestamp: string;
    };
    const [typing, setTyping] = useState(false);
    
    const [inputValue, setInputValue] = useState('');
    const [messages, setMessages] = useState<Message[]>([]);
    

      const handleInputChange = (event:any) => {
        setInputValue(event.target.value);
      };

      const handleSendWithKeyboard = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
          handleSendMessage(e as unknown as FormEvent<HTMLFormElement>);
        }
      };
      
      const handleSendMessage = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (inputValue.trim() !== '') {
          const newMessage: Message = {
            sender: 'user',
            content: inputValue,
            timestamp: new Date().toISOString(),
          };
      
          const newMessages = [...messages, newMessage];
          setMessages(newMessages);
          setInputValue('');
          setTyping(true);
      
          await processMessageToAI(newMessage.content);
        }
      };
      
      const processMessageToAI = async (userQuery: string) => {
        try {
          const response = await fetch(`${process.env.REACT_APP_AI}/api/generate`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ content: userQuery }),
          });
      
          if (response.ok) {
            const data = await response.json();
            console.log('Send Message successful!', data);
            handleBotMessage(data.response);
          } else {
            throw new Error('Send message failed');
          }
        } catch (error) {
          console.error(error);
          window.alert('Message failed to send.');
        }
      
        setTyping(false);
      };
      
      useEffect(() => {
        const fetchBotResponse = async () => {
          if (typing) {
            try {
              const response = await fetch(`${process.env.REACT_APP_AI}/api/generate`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({ content: messages[messages.length - 1].content }),
              });
      
              if (response.ok) {
                const data = await response.json();
                console.log('Bot response:', data.response);
                handleBotMessage(data.response);
              } else {
                throw new Error('Network response was not ok');
              }
            } catch (error) {
              console.error(error);
            }
            setTyping(false);
          }
        };
      
        fetchBotResponse();
      }, [typing, messages]);
      
      const handleBotMessage = (dataContent: string) => {
        const newMessage: Message = {
          sender: 'bot',
          content: dataContent,
          timestamp: new Date().toISOString(),
        };
        const newMessages = [...messages, newMessage];
        setMessages(newMessages);
      };

  return (
    <div>
      {openChatBot ?(
      <div>
        <div className={classes.main_container}>
          <div className={classes.chatbot_header}>
          <img src="/images/chatbotUILogo.png"/>
              <div className={classes.header_right}>
                <div className={classes.insightful_precise}>Insightful, Precise</div>
                <div className={classes.neobank_statistic}>Neobank Statistic</div>
              </div>
          </div>

          <div className={classes.chatbot_messages}>
                {messages.map((message, i) => {
                  return <div key={i}>
                  {message.sender === 'user' ? (
                    <div className={classes.userMessageBubble}><span className={classes.banker_gpt}>User</span>
                    {message.content}
                 </div>
                  ) : (
                    <div className={classes.botMessageBubble}><span className={classes.banker_gpt}>BankerGPT</span>
                      {message.content}
                    </div>
                  )}
                </div>
                })}
                
          </div>

      <div className={classes.bottom_container}>          
        <div className={classes.li_tag}>
          <form onSubmit={handleSendMessage}>
            <input type="hidden" value="Virtual Bank"/>
            <button className={classes.keyword} onClick={() => setInputValue("Virtual Bank")}> Virtual Bank</button>
            </form>
            <form onSubmit={handleSendMessage}>
            <input type="hidden" value="WEB3.0"/>
            <button className={classes.keyword} onClick={() => setInputValue("WEB3.0")}> WEB3.0</button>
            </form>
            <form onSubmit={handleSendMessage}>
            <input type="hidden" value="Payment Tech"/>
            <button className={classes.keyword} onClick={() => setInputValue("Payment Tech")}>Payment Tech</button>
            </form>
            <form onSubmit={handleSendMessage}>
            <input type="hidden" value="Dapp"/>
            <button className={classes.keyword} onClick={() => setInputValue("Dapp")}>Dapp</button>
            </form>
            <form onSubmit={handleSendMessage}>
            <input type="hidden" value="New App"/>
            <button className={classes.keyword} onClick={() => setInputValue("New App")}>New App</button>
            </form>
            
        </div>
        <div className={classes.chatbotMessage}>  
          <form onSubmit={handleSendMessage}>
              <input placeholder="Ask Anythink" onChange={handleInputChange} value={inputValue} onKeyDown={handleSendWithKeyboard}/>
            <button type="submit">Send</button>
          </form>
        </div>
      </div>
    </div>
      </div>
      ): (   
        <div></div>      
      )}

      <button className={classes.vector} onClick={toggleAIChatBot}/>
    </div>
  );
} */
// pink button
interface KeyWordProps {
  height: number;
  content: string;
  fontSize: number;
  onClick?: () => void;
}

export function KeyWord({
  height = 50,
  fontSize = 20,
  content,
  onClick,
}: KeyWordProps) {
  const style = {
    height: height,
    width: content.length * fontSize * 0.6 + 40, //根据内容长短变化
    fontSize: fontSize,
    borderRadius: height / 2, //两边圆角
    color: "#CE2A40",
  };
  return (
    <div className={classes.pinkbutton} onClick={onClick}>
      {content}
    </div>
  );
}
/* search input */
interface SearchInputProps {
  placeholder: string;
  style: React.CSSProperties;
}

export function SearchInput({ placeholder, style }: SearchInputProps) {
  return (
    <input
      type={"search"}
      className={classes.inputField}
      style={style}
      placeholder={placeholder}
    />
  );
}

export function SearchSection() {
  const navigate = useNavigate();
  const [searchField, setSearchField] = useState("");

  function handleSearchOnClick(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    navigate(`/search?query=${encodeURIComponent(searchField)}`);
  }

  function handlePopularOnClick(keyword:string) {
    navigate(`/search?query=${encodeURIComponent(keyword)}`);
  }


  return (
    <div className={classes.searchSection}>
      <div className={classes.search_box}>
        <form className={classes.search}>
          <input
            type={"search"}
            className={classes.inputField}
            style={{
              height: "4.15rem",
              width: "100%",
              backgroundPosition: '1.5rem',
              backgroundSize: '1.9rem',
              fontSize: "1.5rem",
              paddingLeft: '5.15rem',
            }}
            placeholder={
              "Search Your Interested Banks, Technologies or Products"
            }
            onChange={(e) => setSearchField(e.target.value)} 
            value={searchField}
          />
          <button
            type={"submit"}
            className={classes.searchButton}
            onClick={handleSearchOnClick}
          >
            Search
          </button>
        </form>
      </div>
      <div className={classes.popularSearch}>Popular Search:</div>
      <div className={classes.popularSearchList}>
        {popularSearch.map((t) => (
          <KeyWord
            height={60}
            content={t.content}
            fontSize={20}
            key={t.id}
            onClick={() => handlePopularOnClick(t.content)}
          />
        ))}
      </div>
    </div>
  );
}

interface HeaderTextProps {
  title: string;
  subtitle: string;
}

function HeaderText({ title, subtitle }: HeaderTextProps) {
  return (
    <div className={classes.headerText}>
      <h1>{title}</h1>
      <p>{subtitle}</p>
    </div>
  );
}

type NewsItem = {
  id: string;
  title: string;
  imgUrl: string;
  source: string;
  type: string;
  updateTime: string;
  tag: string;
  language: string;
};

// time and place selectors
export function RecentNews() {
  const [timeIndex, setTimeIndex] = useState<number>(0);
  const [newsData, setNewsData] = useState<NewsItem[] | null>(null);
  const [currentPage, setCurrentPage] = useState(1);

  const timeList: string[] = ["This Week", "This Month", "This Year"];

  function handleClickOnTime() {
    if (timeIndex + 1 >= timeList.length) {
      setTimeIndex(0);
    } else {
      setTimeIndex(() => timeIndex + 1);
    }
  }

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/news/latest`)
      .then((response) => response.json())
      .then((data) => setNewsData(data.content))
      .catch((error) => console.error(error));
  }, []);

  const classNames = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j"];

  return (
    <Section
      heading={"Recent News"}
      subheading={"about Neobanks"}
      subheadingStyle={{
        color: "#B09EA0",
        fontFamily: "Exo 2",
        fontSize: "1.25rem",
        fontWeight: 500,
      }}
    >
      <div className={classes.news}>
        {newsData === null ? (
          <LoadingSign />
        ) : (
          <PaginationBox initPageSize={10} currentPage={currentPage} onPageChange={setCurrentPage}>
          {newsData.map((news, index) => {
            return (
              <div key={index % 10} className={classes[classNames[index % 10]]}>
                <NewsCard
                  title={news.title}
                  displayImg={news.imgUrl !== null}
                  imgUrl={news.imgUrl}
                  date={dateFormatter(news.updateTime)}
                  tags={news.tag ? news.tag.split(",") : ["No Tags"]} 
                  url={news.source}
                  isVertical={index % 10 === 0}
                />
              </div>
            );
          })}
          </PaginationBox>
        )}
      </div>
      {/* PaginationBox */}
    </Section>
  );
}

// link of learn more
interface LearnMoreLink {
  text: string;
  link: string;
  style?: React.CSSProperties;
}

export function LearnMoreLinkProps({ text, link, style }: LearnMoreLink) {
  return (
    <div className={classes.learnMore} style={style}>
      <Link to={link}>{text}</Link>
    </div>
  );
}

/* innovative product section*/
type ReceivedProductProps = {
  id: string;
  name: string;
  description: string;
  productType: string;
  license: [];
  link: string;
  clientType: string;
  innovation: string;
  campaign: any;
  innovative: boolean;
  companyName: string;
  companyLocation: string;
  companyLogoURL: string;
};
export function ProductSection() {
  const [productData, setProductData] = useState<ReceivedProductProps[] | null>(
    null,
  );

  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/companyproduct/innovative`)
      .then((response) => {
        console.log(response);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.text();
      })
      .then((text) => {
        try {
          return JSON.parse(text);
        } catch (error) {
          console.error("Could not parse JSON: ", error);
          console.log("Response text: ", text);
          throw error;
        }
      })
      .then((data) => setProductData(data.content))
      .catch((error) => console.error(error));
  }, []);

  return (
    <div className={classes.ProductSection}>
      <div className={classes.productHeader}>
        <h1>
          <svg
            width="2.1rem"
            height="2.1rem"
            viewBox="0 0 42 42"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M34.125 23.625C34.1283 24.1601 33.9658 24.6832 33.6596 25.1221C33.3535 25.561 32.9188 25.8943 32.4155 26.0761L23.9417 29.1933L20.8245 37.6605C20.6399 38.162 20.3059 38.5948 19.8676 38.9006C19.4293 39.2063 18.9078 39.3702 18.3734 39.3702C17.839 39.3702 17.3175 39.2063 16.8792 38.9006C16.4409 38.5948 16.1069 38.162 15.9223 37.6605L12.7969 29.2031L4.32799 26.0859C3.82649 25.9013 3.39369 25.5674 3.08798 25.1291C2.78226 24.6908 2.61835 24.1692 2.61835 23.6348C2.61835 23.1005 2.78226 22.5789 3.08798 22.1406C3.39369 21.7023 3.82649 21.3683 4.32799 21.1838L12.8018 18.0666L15.919 9.5993C16.1036 9.09781 16.4376 8.665 16.8759 8.35929C17.3142 8.05357 17.8357 7.88966 18.3701 7.88966C18.9045 7.88966 19.426 8.05357 19.8643 8.35929C20.3026 8.665 20.6366 9.09781 20.8212 9.5993L23.9384 18.0731L32.4056 21.1903C32.9082 21.3695 33.3431 21.6996 33.6509 22.1354C33.9586 22.5712 34.1242 23.0915 34.125 23.625ZM24.9375 7.875H27.5625V10.5C27.5625 10.8481 27.7008 11.1819 27.9469 11.4281C28.1931 11.6742 28.5269 11.8125 28.875 11.8125C29.2231 11.8125 29.557 11.6742 29.8031 11.4281C30.0492 11.1819 30.1875 10.8481 30.1875 10.5V7.875H32.8125C33.1606 7.875 33.4945 7.73672 33.7406 7.49058C33.9867 7.24444 34.125 6.9106 34.125 6.5625C34.125 6.2144 33.9867 5.88056 33.7406 5.63442C33.4945 5.38828 33.1606 5.25 32.8125 5.25H30.1875V2.625C30.1875 2.2769 30.0492 1.94306 29.8031 1.69692C29.557 1.45078 29.2231 1.3125 28.875 1.3125C28.5269 1.3125 28.1931 1.45078 27.9469 1.69692C27.7008 1.94306 27.5625 2.2769 27.5625 2.625V5.25H24.9375C24.5894 5.25 24.2556 5.38828 24.0094 5.63442C23.7633 5.88056 23.625 6.2144 23.625 6.5625C23.625 6.9106 23.7633 7.24444 24.0094 7.49058C24.2556 7.73672 24.5894 7.875 24.9375 7.875ZM39.375 13.125H38.0625V11.8125C38.0625 11.4644 37.9242 11.1306 37.6781 10.8844C37.432 10.6383 37.0981 10.5 36.75 10.5C36.4019 10.5 36.0681 10.6383 35.8219 10.8844C35.5758 11.1306 35.4375 11.4644 35.4375 11.8125V13.125H34.125C33.7769 13.125 33.4431 13.2633 33.1969 13.5094C32.9508 13.7556 32.8125 14.0894 32.8125 14.4375C32.8125 14.7856 32.9508 15.1194 33.1969 15.3656C33.4431 15.6117 33.7769 15.75 34.125 15.75H35.4375V17.0625C35.4375 17.4106 35.5758 17.7444 35.8219 17.9906C36.0681 18.2367 36.4019 18.375 36.75 18.375C37.0981 18.375 37.432 18.2367 37.6781 17.9906C37.9242 17.7444 38.0625 17.4106 38.0625 17.0625V15.75H39.375C39.7231 15.75 40.057 15.6117 40.3031 15.3656C40.5492 15.1194 40.6875 14.7856 40.6875 14.4375C40.6875 14.0894 40.5492 13.7556 40.3031 13.5094C40.057 13.2633 39.7231 13.125 39.375 13.125Z"
              fill="url(#paint0_linear_3047_23391)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_3047_23391"
                x1="1.13174"
                y1="5.63092"
                x2="37.6399"
                y2="11.9616"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#ED1522" />
                <stop offset="1" stopColor="#E66E48" />
              </linearGradient>
            </defs>
          </svg>
          Innovative Product
        </h1>
        <p>on Nbanker</p>
      </div>
      {productData === null ? (
        <LoadingSign />
      ) : (
        <PaginationBox initPageSize={1} currentPage={currentPage} onPageChange={setCurrentPage}>
          {productData
            .map((product) => {
              return {
                productClass: product.productType,
                productName: product.name,
                productDescription: product.description,
                isInnovative: product.innovative,
                tags: [],
                offeredFrom: {
                  imgUrl: product.companyLogoURL,
                  title: product.companyName,
                  subtitle: product.companyLocation,
                  bankUrl: product.companyName,
                },
              };
            })
            .map((product, index) => {
              console.log(product);
              return <Product key={index} {...product} />;
            })}
        </PaginationBox>
      )}
    </div>
  );
}

interface ProductProps extends ProductCardProps {
  offeredFrom: BankProps;
}

function Product({
  productClass,
  productName,
  productDescription,
  isInnovative,
  tags,
  offeredFrom,
}: ProductProps) {
  const product: ProductCardProps = {
    productClass: productClass,
    productName: productName,
    productDescription: productDescription,
    isInnovative: isInnovative,
    tags: tags,
  };
  return (
    <div className={classes.products_container}>
      <div className={classes.productcard}>
        <ProductCard {...product} />
      </div>
      <div className={classes.product_bank}>
        <h1>Offered From</h1>
        <div>
          <Bank
            imgUrl={offeredFrom.imgUrl}
            title={offeredFrom.title}
            subtitle={offeredFrom.subtitle}
            bankUrl={offeredFrom.bankUrl}
          />
        </div>
        <Link to={"/search?query=all"} className={classes.link}>
          View All Banks with this Product
        </Link>
      </div>
    </div>
  );
}

/* popular bank section */
export function PopularBanksSection() {
  let banksData: BankProps[] = [
    {
      imgUrl: "./images/liviBankIco.png",
      title: "Livi Bank",
      subtitle: "Hong Kong Banks",
      bankUrl: "livi bank", //Bank uuid string
    },
    {
      imgUrl: "./images/moxBankIco.png",
      title: "MOXBank",
      subtitle: "Hong Kong Banks",
      bankUrl: "moxbank",
    },
    {
      imgUrl: "./images/ZABankIco.png",
      title: "ZA Bank",
      subtitle: "Hong Kong Banks",
      bankUrl: "za bank",
    },
    {
      imgUrl: "./images/AirstarBankIco.png",
      title: "Airstar Bank",
      subtitle: "Hong Kong Banks",
      bankUrl: "airstarbank",
    },
    {
      imgUrl: "./images/weLabIco.png",
      title: "weLab Bank",
      subtitle: "Hong Kong Banks",
      bankUrl: "welab bank",
    },
    {
      imgUrl: "./images/fusionBankIco.png",
      title: "Fusion Bank",
      subtitle: "Hong Kong Banks",
      bankUrl: "fusion bank",
    },
  ];

  return (
    <div className={classes.popularBanksSection}>
      <div className={classes.recentNewsHeader}>
        <HeaderText title={"Popular Banks"} subtitle={"on Nbanker"} />
      </div>

      <div className={classes.banklist}>
        {banksData.map((bank, index) => (
          <Bank key={index} {...bank} />
        ))}
      </div>

      <LearnMoreLinkProps text={"Learn More"} link={"/search?query=all"} />
    </div>
  );
}

// design of bank

/* report section */
interface ReportProps {
  imgUrl: string;
  tittle: string;
  subtitle: string;
  link: string; //link to the report
}

function Report({ imgUrl, tittle, subtitle, link }: ReportProps) {
  return (
    <a href={link} target="_blank" className={classes.report}>
      <img src={imgUrl} alt={"Report Image"} />
      <div className={classes.reportTitle}>
        <h2>{tittle}</h2>
        <p>{subtitle}</p>
      </div>
    </a>
  );
}

export function ResearchReportSection() {
  //test data
  const navigate = useNavigate();
  const reports: ReportProps[] = [
    {
      imgUrl:
        "https://assets.kpmg.com/content/dam/kpmg/cn/pdf/en/2023/01/hong-kong-banking-outlook-2023.pdf/jcr:content/renditions/cq5dam.web.400.600.jpeg",
      tittle: "Hong Kong Banking Outlook 2023",
      subtitle:
        "KPMG experts from across a range of areas share their predictions for the banking industry in 2023 and discuss the latest developments ",
      link: "https://kpmg.com/cn/en/home/insights/2023/01/hong-kong-banking-outlook-2023.html",
    },
    {
      imgUrl:
        "https://www.aof.org.hk/images/default-source/default-album/himf_digitalisation_cover_v3.jpg?sfvrsn=4af40068_4",
      tittle: "The Digitalisation of Financial Services in Hong Kong",
      subtitle:
        "Recent experience, regulatory developments and considerations for sustainable innovation and growth",
      link: "https://www.google.com/url?sa=i&url=https%3A%2F%2Fwww.aof.org.hk%2Fdocs%2Fdefault-source%2Fhkimr%2Fapplied-research-report%2Fdrep.pdf&psig=AOvVaw13TNKhS71R5YXqnb_uvuI0&ust=1704355183232000&source=images&cd=vfe&opi=89978449&ved=0CBMQjhxqFwoTCKj2tv3fwIMDFQAAAAAdAAAAABAD",
    },
    {
      imgUrl:
        "https://www.citigroup.com/rcs/v1/media/icgPublic/akpublic/storage/retrieveMediaFile/60f59765770344720137ea16.jpg",
      tittle: "Digital Neobanks: Popular But Not Profitable ",
      subtitle:
        "Neobanks have demonstrated their ability to add customers at pace. But so far their ability to turn a profit is unproven, according to Citi research analyst Ronit Ghose and team.",
      link: "https://www.citigroup.com/global/insights/global-insights/digital-neobanks-popular-but-not-profitable-",
    },
  ];

  return (
    <div className={classes.box}>
      <div className={classes.researchReportSection}>
        <HeaderText title={"Research Report"} subtitle={"about Neobank"} />
        {reports.map((report, index) => (
          <Report key={index} {...report} />
        ))}
      </div>

      <div>
        <div className={classes.nbanker}>
          {/* Logo SVG */}
          <svg
            width="9.15rem"
            height="11.1rem"
            viewBox="0 0 183 222"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M168 31.7927L143.226 15L115.756 31.7927H123.22L134.707 27.5075C134.713 27.5861 134.716 27.6668 134.716 27.7496C134.716 29.5983 134.017 32.5157 132.618 36.502C131.307 40.4305 129.515 45.0234 127.242 50.2806C125.057 55.4801 122.478 61.1707 119.506 67.3523C116.621 73.4761 113.561 79.6866 110.327 85.9837C107.18 92.2231 103.989 98.3469 100.755 104.355C97.6079 110.306 94.6358 115.765 91.8385 120.734C92.1882 115.13 92.6252 109.295 93.1497 103.229L94.7232 84.8572C95.3351 78.7333 95.947 72.6962 96.5589 66.7457C97.2583 60.7951 97.8702 55.1335 98.3947 49.7607C99.0066 44.3879 99.5748 39.4195 100.099 34.8555C100.624 30.2915 101.061 26.3341 101.411 22.9834L100.886 22.4634C97.8265 22.5212 95.204 22.6079 93.0186 22.7234C90.8332 22.8389 88.7789 23.0123 86.8558 23.2433C85.0201 23.4167 83.1843 23.6766 81.3486 24.0233C79.6003 24.3121 77.546 24.6876 75.1858 25.1498V26.1897C76.0599 26.5941 76.497 27.2874 76.497 28.2695V29.916C73.1752 36.4442 69.8097 43.1747 66.4005 50.1073C62.9913 57.04 59.5384 63.9437 56.0417 70.8186C52.6325 77.6935 49.2233 84.4239 45.8141 91.0099C42.4049 97.5959 39.1268 103.806 35.9798 109.641C32.8328 115.419 29.817 120.705 26.9323 125.5C24.0475 130.237 21.4251 134.223 19.0648 137.459C18.3655 138.267 17.6662 138.932 16.9669 139.452C16.2675 139.914 15.6993 140.145 15.2622 140.145L15 141.358C17.1854 141.474 19.1085 141.56 20.7694 141.618C22.4303 141.676 24.0038 141.705 25.4899 141.705C26.8011 141.705 27.9812 141.676 29.0302 141.618C29.9918 141.618 30.8223 141.589 31.5216 141.532C32.3083 141.474 32.9639 141.416 33.4884 141.358C36.4606 134.83 39.5638 127.811 42.7982 120.3C46.12 112.79 49.5292 104.991 53.0259 96.9026C56.6099 88.8146 60.2814 80.5532 64.0403 72.1185C67.7991 63.626 71.6017 55.1624 75.448 46.7277C75.0984 51.6383 74.705 56.8666 74.2679 62.4128C73.9183 67.9589 73.4812 73.5916 72.9567 79.3111C72.5196 85.0305 72.0388 90.7788 71.5143 96.556C71.0772 102.275 70.5965 107.793 70.072 113.108C69.6349 118.423 69.1541 123.42 68.6296 128.1C68.1925 132.779 67.7554 136.91 67.3184 140.492L68.1051 141.358C70.1157 141.532 72.0825 141.647 74.0057 141.705C76.0162 141.82 77.8083 141.878 79.3817 141.878C82.791 141.878 85.5008 141.791 87.5114 141.618C88.6478 141.56 89.6968 141.474 90.6584 141.358H90.9206C92.4941 138.065 94.5047 134.021 96.9523 129.226C99.4 124.431 102.066 119.174 104.951 113.454C107.923 107.735 111.026 101.755 114.261 95.5161C117.582 89.219 120.861 82.9796 124.095 76.798C127.417 70.5586 130.607 64.5503 133.667 58.7731C136.814 52.9381 139.655 47.6231 142.19 42.828C144.812 38.033 147.042 33.9023 148.877 30.436C149.411 29.4735 149.905 28.5867 150.358 27.7756L158.671 31.7927H168Z"
              fill="white"
            />
            <path
              d="M31.6121 158.606C34.4921 158.606 36.8761 158.894 38.7641 159.47C40.6521 160.014 42.0441 160.91 42.9401 162.158C43.8681 163.406 44.3321 165.086 44.3321 167.198C44.3321 168.51 44.1081 169.694 43.6601 170.75C43.2121 171.806 42.5721 172.67 41.7401 173.342C40.9401 174.014 40.0121 174.462 38.9561 174.686V174.926C40.0441 175.15 41.0681 175.566 42.0281 176.174C42.9881 176.75 43.7561 177.598 44.3321 178.718C44.9081 179.806 45.1961 181.246 45.1961 183.038C45.1961 185.118 44.7161 186.894 43.7561 188.366C42.8281 189.838 41.4841 190.958 39.7241 191.726C37.9641 192.494 35.8681 192.878 33.4361 192.878H21.5321V158.606H31.6121ZM32.1881 172.574C34.2681 172.574 35.7081 172.19 36.5081 171.422C37.3081 170.654 37.7081 169.518 37.7081 168.014C37.7081 166.478 37.2281 165.374 36.2681 164.702C35.3401 164.03 33.8521 163.694 31.8041 163.694H27.9641V172.574H32.1881ZM27.9641 177.518V187.742H32.6681C34.8441 187.742 36.3481 187.262 37.1801 186.302C38.0441 185.342 38.4761 184.062 38.4761 182.462C38.4761 181.438 38.2841 180.558 37.9001 179.822C37.5481 179.086 36.9401 178.526 36.0761 178.142C35.2121 177.726 34.0121 177.518 32.4761 177.518H27.9641ZM58.9722 166.382C62.1082 166.382 64.5082 167.118 66.1722 168.59C67.8362 170.03 68.6682 172.302 68.6682 175.406V192.878H64.2042L62.9562 189.278H62.7642C62.0602 190.206 61.3402 190.99 60.6042 191.63C59.8682 192.238 59.0202 192.67 58.0602 192.926C57.1002 193.214 55.9481 193.358 54.6041 193.358C53.1641 193.358 51.8681 193.07 50.7161 192.494C49.5641 191.918 48.6521 191.038 47.9801 189.854C47.3081 188.638 46.9721 187.118 46.9721 185.294C46.9721 182.606 47.9001 180.59 49.7561 179.246C51.6121 177.87 54.3961 177.118 58.1082 176.99L62.2842 176.846V175.55C62.2842 173.886 61.9322 172.702 61.2282 171.998C60.5242 171.294 59.5642 170.942 58.3482 170.942C57.1962 170.942 56.0281 171.134 54.8441 171.518C53.6921 171.902 52.5561 172.35 51.4361 172.862L49.4681 168.638C50.7801 167.966 52.2361 167.422 53.8361 167.006C55.4361 166.59 57.1482 166.382 58.9722 166.382ZM59.5962 180.686C57.3242 180.782 55.7401 181.246 54.8441 182.078C53.9481 182.878 53.5001 183.966 53.5001 185.342C53.5001 186.558 53.8041 187.438 54.4121 187.982C55.0521 188.526 55.8841 188.798 56.9082 188.798C58.4122 188.798 59.6922 188.302 60.7482 187.31C61.8042 186.286 62.3322 184.782 62.3322 182.798V180.59L59.5962 180.686ZM86.6955 166.382C89.4155 166.382 91.5595 167.134 93.1276 168.638C94.6956 170.142 95.4796 172.574 95.4796 175.934V192.878H89.0955V177.134C89.0955 175.182 88.7595 173.726 88.0875 172.766C87.4155 171.774 86.3595 171.278 84.9195 171.278C82.7755 171.278 81.3195 172.046 80.5515 173.582C79.7835 175.086 79.3995 177.278 79.3995 180.158V192.878H73.0155V166.862H77.9115L78.8235 170.27H79.0635C79.6395 169.374 80.3115 168.638 81.0795 168.062C81.8475 167.486 82.7115 167.07 83.6715 166.814C84.6315 166.526 85.6395 166.382 86.6955 166.382ZM106.202 173.726C106.202 174.558 106.17 175.438 106.106 176.366C106.042 177.262 105.962 178.142 105.866 179.006H106.058C106.218 178.622 106.458 178.206 106.778 177.758C107.098 177.278 107.434 176.814 107.786 176.366C108.17 175.886 108.538 175.454 108.89 175.07L115.658 166.862H122.858L113.402 178.094L123.434 192.878H116.09L109.034 181.742L106.202 184.238V192.878H99.8656V156.398H106.202V173.726ZM134.877 166.382C137.117 166.382 139.037 166.862 140.637 167.822C142.269 168.75 143.533 170.094 144.429 171.854C145.325 173.582 145.773 175.694 145.773 178.19V181.262H129.837C129.901 183.63 130.477 185.47 131.565 186.782C132.685 188.062 134.253 188.702 136.269 188.702C137.869 188.702 139.293 188.542 140.541 188.222C141.789 187.87 143.085 187.374 144.429 186.734V191.582C143.213 192.19 141.949 192.638 140.637 192.926C139.325 193.214 137.709 193.358 135.789 193.358C133.357 193.358 131.197 192.878 129.309 191.918C127.453 190.926 125.997 189.438 124.941 187.454C123.885 185.47 123.357 183.006 123.357 180.062C123.357 177.086 123.837 174.59 124.797 172.574C125.757 170.526 127.101 168.99 128.829 167.966C130.589 166.91 132.605 166.382 134.877 166.382ZM134.973 170.846C133.533 170.846 132.365 171.374 131.469 172.43C130.605 173.454 130.093 174.99 129.933 177.038H139.725C139.725 175.822 139.549 174.75 139.197 173.822C138.845 172.894 138.317 172.174 137.613 171.662C136.941 171.118 136.061 170.846 134.973 170.846ZM162.127 166.382C162.575 166.382 163.039 166.398 163.519 166.43C163.999 166.462 164.399 166.526 164.719 166.622L164.143 172.238C163.823 172.174 163.439 172.126 162.991 172.094C162.575 172.03 162.127 171.998 161.647 171.998C160.847 171.998 160.063 172.158 159.295 172.478C158.527 172.766 157.839 173.214 157.231 173.822C156.623 174.398 156.127 175.15 155.743 176.078C155.391 177.006 155.215 178.11 155.215 179.39V192.878H148.831V166.862H153.727L154.591 171.374H154.927C155.407 170.446 155.999 169.614 156.703 168.878C157.439 168.11 158.255 167.502 159.151 167.054C160.079 166.606 161.071 166.382 162.127 166.382Z"
              fill="white"
            />
          </svg>

          <div className={classes.text}>
            <p>1st Global Neobank Research Center</p>
            <p>PolyU endorse & take 10% share</p>
          </div>
          <KeyWord
            height={60}
            content={"About Us"}
            fontSize={20}
            onClick={() => navigate("/AboutUs")}
          />
        </div>
      </div>
    </div>
  );
}

